import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';

import { Spinner } from '@/components/common/Spinner';
import { SelectOptionProps } from '@/models/SelectOption';
import { UserType } from '@/models/User';

type Props = {
  userType: UserType | null | undefined;
  value: number | null;
  options: SelectOptionProps[] | null;
  loading: boolean;
  onChange: (id: number | null) => void;
};

export default function PartnerSelectField({ userType, value, options, loading, onChange }: Props) {
  const fieldDisabled = useMemo(() => {
    return userType !== UserType.Adf || loading || options?.length === 0;
  }, [userType, loading, options]);
  return (
    <FormControl fullWidth>
      <InputLabel id='partner-label'>Partner</InputLabel>
      <Select
        labelId='partner-label'
        label='Partner'
        MenuProps={{ PaperProps: { sx: { maxHeight: 300, maxWidth: 460 } } }}
        value={value ? value.toString() : ''}
        onChange={(e: SelectChangeEvent) => onChange(Number(e.target.value))}
        disabled={fieldDisabled}
        endAdornment={
          fieldDisabled ? (
            <Box marginRight={2}>
              <Spinner type='circular' size={18} />
            </Box>
          ) : undefined
        }
      >
        {options?.map((p) => (
          <MenuItem key={p.value} value={p.value}>
            {p.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
